module.exports = ".form-label {\r\n    font-weight: bold;\r\n}\r\n\r\n.form-value {\r\n    border-style: none none solid none;\r\n    border-color: #f59121;\r\n    border-width: 2px;\r\n    /* Set a min height because the value might be empty, causing the 'underline' to collapse to the top of the box */\r\n    min-height: 14pt;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/training-user-detail/training-user-detail.component.css
// module id = ./src/app/components/training-user-detail/training-user-detail.component.css
// module chunks = main